export default {
  valueType: 'textarea',
  FormItemProps: {
    label: '文本域',
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    placeholder: "",
    style: {}
  }
}
